import { reactive, toRefs } from 'vue'

import type { ChatEvent } from '~/api/shopping-assistant/types'

type LoaderVariant = 'spinner' | 'text'

function createDefaults() {
  return {
    loaderVariant: 'spinner' as LoaderVariant,
    inputText: '',
    inputWithSuggestions: true,
    events: [] as ChatEvent[],
    isLoading: true,
    isProcessing: false,
    chatNotFoundError: false,
    chatId: null as string | null,
    streamedMessage: '',
  }
}

export function useShoppingAssistantState(initialChatId: string | null) {
  const state = reactive({ ...createDefaults(), chatId: initialChatId })

  function resetState() {
    Object.assign(state, createDefaults())
  }

  return {
    ...toRefs(state),
    resetState,
  }
}
